document.addEventListener('DOMContentLoaded', function() {
  const heartSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M 15 7 C 8.9424416 7 4 11.942442 4 18 C 4 22.096154 7.0876448 25.952899 10.851562 29.908203 C 14.615481 33.863507 19.248379 37.869472 22.939453 41.560547 A 1.50015 1.50015 0 0 0 25.060547 41.560547 C 28.751621 37.869472 33.384518 33.863507 37.148438 29.908203 C 40.912356 25.952899 44 22.096154 44 18 C 44 11.942442 39.057558 7 33 7 C 29.523564 7 26.496821 8.8664883 24 12.037109 C 21.503179 8.8664883 18.476436 7 15 7 z"></path></svg>`;

  function createHeartBurst(wrapper) {
    const particleCount = 5;
    
    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement('div');
      particle.className = 'heart-particle';
      particle.innerHTML = heartSVG;
      
      const tx = (Math.random() - 0.5) * 60;
      const ty = -25 - Math.random() * 35;
      const delay = Math.random() * 0.1;
      const duration = 1.2 + Math.random() * 0.5
      
      particle.style.setProperty('--tx', `${tx}px`);
      particle.style.setProperty('--ty', `${ty}px`);
      particle.style.setProperty('--delay', `${delay}s`);
      particle.style.setProperty('--duration', `${duration}s`);
      particle.style.left = '50%';
      particle.style.top = '20%';
      particle.style.marginLeft = '-6px';
      
      wrapper.appendChild(particle);
      
      setTimeout(() => particle.remove(), (delay + duration) * 1000 + 100);
    }
  }

  function triggerBounce(wrapper) {
    wrapper.classList.remove('do-bounce');
    void wrapper.offsetWidth;
    wrapper.classList.add('do-bounce');
    setTimeout(() => wrapper.classList.remove('do-bounce'), 500);
  }

  // Use capture phase to catch it early
  document.addEventListener('click', function(e) {
    const wrapper = e.target.closest('.favorite-button-wrapper');
    if (!wrapper) return;
    
    const button = wrapper.querySelector('rivo-favorite-button');
    if (!button) return;
    
    const wasActive = button.classList.contains('rivo-favorite-active');
    
    setTimeout(() => {
      const isNowActive = button.classList.contains('rivo-favorite-active');
      if (isNowActive && !wasActive) {
        createHeartBurst(wrapper);
        triggerBounce(wrapper);
      }
    }, 150);
  }, true); // <-- capture phase
});